import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';

export interface UniqueWhichFieldResponse  {
 count: number;
  data: string[];
}

@Injectable({
  providedIn: 'root'
})
export class LmsDsManualEntryService {

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService
  ) {}

   getUniqueWhichField(): Observable<UniqueWhichFieldResponse> {
    return this.http
      .get<UniqueWhichFieldResponse>(
        `${AppConstants.API_ENDPOINT}${AppConstants.API.LMS_DS_MANUAL_ENTRY.GET_UNIQUE_WHICHFIELD}`
      )
      .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  
    getNdaData(searchValue): Observable<any[]> {
      console.log("called in seervice", searchValue);
      let paramsInput = new HttpParams();
      paramsInput = paramsInput.append("brand_name", searchValue);
      return this.http.get<any[]>(
        `${AppConstants.API_ENDPOINT}${AppConstants.API.MOLECULE.GET}`,
        { params: paramsInput }
      ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    }
  

  submitManualEntry(payload: any) {
  return this.http
    .post(`${AppConstants.API_ENDPOINT}${AppConstants.API.LMS_DS_MANUAL_ENTRY.ADD_LMS_DS_ENTRY}`, payload)
    .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
}
}
